var map = {
	"./1.png": "775a",
	"./10.png": "4abd",
	"./2.png": "8e30",
	"./3.png": "1f66",
	"./4.png": "5fa5",
	"./5.png": "c037",
	"./6.png": "338d",
	"./7.png": "0f01",
	"./8.png": "eadf",
	"./9.png": "6846",
	"./AUD-USD.png": "894e",
	"./EUR-USD.png": "f945",
	"./GBP-USD.png": "8645",
	"./JPY-USD.png": "9264",
	"./NZD-USD.png": "962d",
	"./USD-CAD.png": "bf5d",
	"./USD-CHF.png": "756b",
	"./adenisov.png": "bf1f",
	"./cc_logo.png": "795c",
	"./chart_new.png": "f094",
	"./common_room.png": "01da",
	"./diplom_1.png": "6dae",
	"./diplom_2.png": "123f",
	"./ft_logo.png": "7828",
	"./gce_logo.png": "19e8",
	"./lentaru_logo.png": "5aca",
	"./manager.png": "b2e1",
	"./player-splash.png": "268c",
	"./rbk_logo.png": "0815",
	"./stockchart.png": "775e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";